<template>
  <div>
    <div class="shadow-card">
      <h3 class="font32 fw700 my-4 gray900">Questions and Answers</h3>
      <div class="search-container w-100">
        <form onSubmit="return false;" class="w-100 d-flex align-items-center searchContainer">
          <font-awesome-icon :icon="['fal', 'search']" :style="{ color: getPrimaryColor() }" @click="searchQuestions()" class="cp pr-3 ml-3" />
          <input type="search" class="search-input-state w-100" placeholder="Search Question" v-model="query" @input="callDebounce" @keyup.enter="callDebounce" />
          <a-icon v-if="query" class="close-icon mr-3 cp" style="width: fit-content;" type="close" :size="'large'" @click="handleClearSearch" />
        </form>
        <button @click="handlefilterModal" class="search-button primary-button position-relative">
          <img src="../../../assets/icons/bars-filter-light.png" alt="Filter icon" />
          <p class="apply">Apply Filters</p>
          <div v-if="category !== 'All'" class="active-filter-indicator" :style="{ background: getPrimaryColor() }" />
        </button>
      </div>
      <div :style="{ display: 'flex', 'flex-direction': 'row-reverse', 'justify-content': 'space-between' }">
        <div class="clear-filter text-right">
          <span v-if="category !== 'All'" :style="{ color: ' #0F1734' }" class="ml-5 hyper-link cp" @click="clearFilters()">Clear Filters</span>
        </div>
        <!-- applied filters -->
        <div class="filter-container">
          <div class="appliedFilter" v-if="category !== 'All'">Applied Filter:</div>
          <div v-if="category !== 'All'" class="filterTypeBox">
            <div class="filterTypeText">{{ category }}</div>
            <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="() => clearFilters()"></i>
          </div>
        </div>
      </div>
      <div>
        <h4>
          <span
            :style="{
              'font-weight': 'bold',
              cursor: 'pointer',
              fontFamily: 'Lato',
              fontStyle: normal,
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '24px',
              textAlign: 'center',
              textTransform: 'capitalize',
              color: getPrimaryColor(),
            }"
            id="ask"
            @click="() => $refs.CreateNewPostModal.show('add', null, 'question')"
            >Ask a Question</span
          >
        </h4>
      </div>
      <!-- <TreatmentQuestionModal ref="treatmentQuestionModal" /> -->
      <EditQuestion ref="treatmentQuestionModal" :userName="this.authUser.user.display_name" :fetchPosts="searchQuestions" :render="true" />
    </div>
    <div class="ask_doctor" :style="{ background: getSecondaryColor() }">
      <p class="ask_doctor--main">Get your questions answered by real Physician.</p>
      <p class="ask_doctor--sub">Would you like verified Physician to answer your questions?</p>
      <p class="ask_doctor--sub">Checkout DoveMed's Ask a Doctor!</p>
      <a target="_blank" :href="`${SSO_BASE_URL}/ask-a-doctor/`" class="ask_doctor--link d-flex justify-content-end">
        <div>
          <div class="ask_doctor--link--main">Ask a Doctor</div>
          <div class="ask_doctor--link--sub">By DoveMed</div>
        </div>
        <div class="ask_doctor--link--arrow">&rarr;</div>
      </a>
    </div>
    <div v-if="questions.data && !isFetchingQuestion">
      <div>
        <div
          class="d-flex"
          :style="{
            'flex-direction': 'row',
            'justify-content': 'space-between',
          }"
        >
          <div
            :style="{
              fontFamily: 'Lato',
              fontStyle: normal,
              fontWeight: 700,
              fontSize: '20px',
              lineHeight: '30px',
              color: '#0F1734',
            }"
            class="text-left mb-3"
            v-if="!questions.data || !isFetchingQuestion"
          >
            {{ questions.count }} Results
          </div>
          <div class="text-right">
            <a-dropdown v-if="!questions.data || !isFetchingQuestion" :style="{ marginTop: '7px', cursor: 'pointer' }">
              <p class="sort-text">
                Show
                <span style="font-weight: 700">{{ sortKey === "Newest" ? "Newest First" : sortKey === "Oldest" ? "Oldest First" : "Most Popular" }}</span>
                <font-awesome-icon size="lg" style="margin-left: 8px" :icon="['fas', 'angle-down']" />
              </p>
              <template #overlay>
                <a-menu @click="e => sortList(e.key)">
                  <a-menu-item key="Newest">Newest First</a-menu-item>
                  <a-menu-item key="Oldest">Oldest First</a-menu-item>
                  <a-menu-item key="Popular">Most Popular</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </div>
        <div v-for="question in questions.data" :key="question.id">
          <Question :quesData="question" :showFullScreen="showFullScreen" :fetchPosts="searchQuestions" :handleOtherModals="handleOtherModals"></Question>
        </div>
      </div>

      <div v-if="questions.count" class="paginationContainer pb-5">
        <a-pagination v-model="currentPage" class="dovemed-custom-pagination" :total="questions.count ? questions.count : 0" show-less-items :pageSize="5" @change="handleChangePage" />
      </div>
    </div>
    <div v-if="isFetchingQuestion" class="d-flex justify-content-center mt-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
    </div>
    <div v-if="!questions.data && !isFetchingQuestion">
      <div class="text-center mb-3">There are no questions found.</div>
    </div>
    <QASearchFilterModal ref="QASearchFilterModal" :setCategory="setCategory" :clearfilter="clear" />
    <PostFullScreen ref="PostFullScreen" />
    <congrats :showInfoModal="showInfoModal" ref="Congrats" />
    <info ref="Info" />
    <CreateNewPostModal ref="CreateNewPostModal" :getPost="clearSearchFilters" :showCongrats="showCongrats" :handleOtherModals="handleOtherModals" questionType="General" />
  </div>
</template>

<script>
import PostFullScreen from "../../Modals/activity/PostFullScreen.vue"
import CreateNewPostModal from "../../Modals/CreateNewPost.vue"
import Congrats from "../../Modals/activity/Congrats.vue"
import Info from "../../Modals/activity/Info.vue"
import { mapGetters } from "vuex"
import Question from "../../Users/Patient/QA/Question"
import AskQuestion from "./AskQuestion"
import Search from "./SearchQA"
import { eventBus } from "../../../main"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import EditQuestion from "../../Modals/activity/EditQuestion.vue"
// import TreatmentQuestionModal from "../../Modals/TreatmentQuestionModal.vue";
import QASearchFilterModal from "../../Modals/QASearchFilterModal.vue"

const QARepository = RepositoryFactory.get("qa")
const AppRepository = RepositoryFactory.get("app")

export default {
  name: "HomeQA",
  components: {
    AskQuestion,
    Search,
    Question,
    // TreatmentQuestionModal,
    EditQuestion,
    QASearchFilterModal,
    PostFullScreen,
    CreateNewPostModal,
    Congrats,
    Info,
  },
  data() {
    return {
      answers: [],
      tabs: {
        search: true,
        ask: false,
      },
      activeTab: "search",
      type: "Medication",
      treatments: null,
      query: "",
      category: "All",
      pagination: null,
      currentPage: 1,
      limit: 5,
      categories: [],
      sortKey: "Newest",
      clear: false,
      categories: [],
    }
  },

  computed: {
    SSO_BASE_URL: () => process.env.SSO_BASE_URL,
    ...mapGetters({
      questions: "QA/getSearchQuestions",
      isFetchingQuestion: "QA/isFetchingQuestion",
    }),
  },
  created() {
    console.warn("QA.vue created")
    this.init()
  },
  updated() {
    this.updateColor()
  },

  mounted() {
    this.updateColor()
    console.log(this.questions, "question search")

    this.searchQuestions()
  },

  methods: {
    /**
     * Change tab based on user selection
     *
     * @param {Object} event
     */
    changeTab(event) {
      if (this.tabs.hasOwnProperty(event.target.id)) {
        console.log(event.target.id)
        this.tabs[this.activeTab] = false
        this.tabs[event.target.id] = true
        this.activeTab = event.target.id
      }
    },

    handleClearSearch(){
      this.query = "";
      this.searchQuestions();
    },

    clearSearchFilters(){
      this.currentPage = 1
      this.clear = true
      this.category = "All"
      this.query = "";
      this.searchQuestions();
    },

    callDebounce: _.debounce(function () {
      this.searchQuestions()
    }, 500),

    clearFilters() {
      this.currentPage = 1
      this.clear = true
      this.category = "All"
      this.searchQuestions()
    },
    showFullScreen(d) {
      this.$refs.PostFullScreen.show(d)
    },
    showInfoModal() {
      if (this.authUser.user.role === "patient" || this.authUser.user.role === "caregiver") {
        this.$refs.Info.show()
      }
    },
    showCongrats() {
      this.$refs.Congrats.show()
    },

    handleOtherModals(modalToOpen, data = null, type = "post", editing = false, tags = [], id) {
      switch (modalToOpen) {
        case "add":
        case "new":
        case "edit":
          this.$refs.CreateNewPostModal.show(editing ? "edit" : "add", data, type, tags, id)
          break
        case "more":
        case "back":
        case "moreOptions":
          this.$refs.CreateNewPostModal.show("more", data, type, tags, id)
          break
      }
    },

    searchQuestions(append = false) {
      // this.currentPage = 1;
      console.log(this.query)
      this.$store.commit("QA/setIsFetchingData", { data: true })
      let selectedCat = this.category.toLowerCase() === "all" ? "" : this.category
      QARepository.searchQuestions(this.query, selectedCat, this.currentPage, this.limit, this.currentCircle.id, this.sortKey)
        .then(res => {
          console.log("response")
          if (res.status === 204) {
            this.$store.commit("QA/setSearchQuestions", {
              data: [],
              pagination: {},
            })
            this.$store.commit("QA/setIsFetchingData", { data: false })
          }
          if (res.data) {
            this.$store.commit("QA/setSearchQuestions", {
              data: res.data.data.data,
              pagination: res.data.data.paginator,
            })
            this.$store.commit("QA/setIsFetchingData", { data: false })
          }

          // this.currentPage += 1
        })
        .catch(err => {})
    },
    handlesearch(e) {
      this.query = e.target.value
      console.log(this.query)
      this.currentPage = 1
      this.searchQuestions()
    },

    init() {
      QARepository.getQuestionCategories()
        .then(res => {
          this.categories.push(...res.data.data)
          this.category = "All"
          console.log(this.categories, res, "cat")
          this.searchQuestions()
        })
        .catch(err => {
          this.setCategory(this.category)
        })
    },

    setCategory(filter = "") {
      this.currentPage = 1
      this.category = filter
      this.clear = false
      this.searchQuestions()
    },
    sortList(key) {
      this.sortKey = key
      this.currentPage = 1
      this.searchQuestions()
    },
    appendLimit() {
      eventBus.$emit("refresh-qa-search-questions")
      console.log("VIEW MORE CLICK")
    },
    handleChangePage(page) {
      console.log(page, "pagination")
      this.currentPage = page
      document.body.scrollTop = 0
      this.searchQuestions()
    },

    handlefilterModal() {
      this.$refs.QASearchFilterModal.show()
    },
    updateColor() {
      console.log("QA - updateColor")
      this.$el.querySelectorAll(".nav-link").forEach(elem => {
        if (elem.classList.contains("router-link-active") || elem.classList.contains("nav-active")) {
          elem.setAttribute("style", ` background: ${this.currentCircle.color_code} !important; color: #fff !important; border: 1px solid ${this.currentCircle.color_code}`)
        } else {
          elem.setAttribute("style", `border: 1px solid ${this.currentCircle.color_code}`)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.active-filter-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  align-self: flex-start;
  margin-top: 18px;
  margin-left: 5px;
  @media screen and (min-width: 701px) {
    top: 0;
    right: 0;
    position: absolute;
    margin-right: 10px;
    margin-top: 15px;
  }
}
@media screen and (max-width: 768px) {
  .search-container {
    flex-direction: column !important;
  }
}
@media screen and (max-width: 427px) {
  .search-btn {
    padding: 12px 24px;
    background: #062b54;
    border-radius: 6px;
    height: 48px;
    color: #ffffff;
    display: block !important;
  }
  .search-button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }

  .search-container {
    flex-direction: column !important;
  }

  .select-container {
    display: block !important;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
  }

  .searchContainer {
    input {
      border: 1px solid #cbd5e1 !important;
      border-radius: 8px !important;
    }
  }

  .apply {
    margin-bottom: 0px !important;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #0f1734 !important;
    display: block !important;
  }
}

.filter-container {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  padding-top: 20px;
}
.filter-text {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #0f1734;
  margin-left: 16px;
  @media screen and (min-width: 701px) {
    display: none;
  }
}
.appliedFilter {
  font-weight: 700;
  font-size: 14px;
  color: #647490;
  line-height: 24px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.filterTypeBox {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  gap: 8px;
  background: #f1f5f9;
  border-radius: 6px;

  .filterTypeText {
    font-weight: 700;
    font-size: 14px;
    color: #0f1734;
  }
}

.select-container {
  display: none;
}

.search-btn {
  display: none;
}
.search-button {
  width: 51px;
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
}

.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
}
.searchContainer {
  background-color: #f1f5f9 !important;
  border-radius: 8px !important;
  border: none !important;

  input {
    border: none !important;
  }
}
.nav-active {
  background: #fff !important;
}
.search-container {
  display: flex;
  margin-top: 24px;
  gap: 24px;

  .search-input-state {
    background: none;
    border-left: 0 !important;
    height: 60px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;

    &:focus {
      outline: none;
    }
  }

  .search-button {
    max-width: 60px;
    min-width: 60px;
    border-radius: 8px;
    height: 60px;
    &:focus {
      outline: none;
    }
  }
}
.nav-pills .nav-link {
  border-radius: 0;
}
.paginationContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.clear-filter {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  text-decoration-line: underline;
  margin-top: 33px;
  margin-right: 28px;
}
.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: context-menu;
}

.search-button {
  max-width: 100px;
  padding: 11px;

  @media screen and (max-width: 900px) {
    padding: 6px;
  }
  @media screen and (max-width: 769px) {
    max-width: 100% !important;
    width: 100%;
  }

  &:focus {
    outline: none;
  }
}

.apply {
  display: none;
}
.ask_doctor {
  background: #062b54;
  padding: 20px;

  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;

  &--main {
    color: rgba(255, 255, 255, 0.87);
    font-size: 24px;
    font-weight: bold;
    line-height: 24px;
  }

  &--sub {
    color: rgba(255, 255, 255, 0.54) !important ;
    font-size: 14px;
    font-weight: bold;
  }

  &--link {
    &--main {
      color: rgba(255, 255, 255, 0.87);
      font-size: 24px;
    }

    &--sub {
      color: rgba(255, 255, 255, 0.87);
      font-size: 10px;
    }

    &--arrow {
      color: rgba(255, 255, 255, 0.87);

      font-size: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/QA/QA.vue